import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .user-manual-approval-modal {
    width: 400px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .status-selector-wrapper {
    margin-bottom: 8px;
  }
  .user-manual-approval-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .user-manual-approval-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
